const en: Record<string, string> = {
  // ── Navigation ──
  nav_home: 'Home',
  nav_shop: 'Shop',
  nav_blueProtect: 'Blue Protect',
  nav_evilEnergy: 'Evil Energy',
  nav_destroyKit: 'Destroy Kit',
  nav_consultations: 'Consultations',
  nav_blog: 'Blog',
  nav_about: 'About Us',
  nav_contact: 'Contact',
  nav_bookConsult: 'Book Consult',
  nav_myOrders: 'My Orders',

  // ── Hero ──
  hero_badge: 'Rooted in Shamanism · Older than Time',
  hero_title1: 'Elevate Your',
  hero_title2: 'Energy',
  hero_shamBadge: '✦ Shamanism ✦',
  hero_shamLabel: 'Shamanism',
  hero_shamDesc: 'is one of the oldest spiritual practices in the world, rooted in indigenous traditions and cultures worldwide — the source of all our rituals.',
  hero_subtitle: 'Premium spiritual products, energy cleansings and personal consultations. Based on thousands of years of shamanic protection knowledge.',
  hero_shopNow: 'Shop Now',
  hero_discoverCollection: 'Discover Collection',

  // ── Trust badges ──
  trust_worldwide: 'Worldwide Shipping',
  trust_quality: 'Premium Quality',
  trust_guarantee: '30-Day Guarantee',
  trust_payment: 'Secure Payment',

  // ── Footer ──
  footer_followText: 'Follow us for daily inspiration from the world of',
  footer_shamanism: 'shamanism',
  footer_followEnd: '& spiritual protection',
  footer_brandDesc: 'Rooted in shamanism — one of the oldest spiritual practices in the world. Authentic protection rituals, sacred tools and personal consultations for everyone who wants to elevate their consciousness.',
  footer_shopTitle: 'Shop',
  footer_infoTitle: 'Information',
  footer_newsletterTitle: 'Newsletter',
  footer_newsletterDesc: 'Receive spiritual tips, exclusive offers and new rituals.',
  footer_newsletterPlaceholder: 'your@email.com',
  footer_newsletterBtn: 'Subscribe',
  footer_copyright: '© 2026 ZpiritualZ. All rights reserved.',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms & Conditions',
  footer_cookies: 'Cookies',
  footer_ship_worldwide: 'Worldwide Shipping',
  footer_ship_worldwide_sub: 'We ship to every country',
  footer_ship_fast: 'Fast Processing',
  footer_ship_fast_sub: 'Order shipped quickly',
  footer_ship_discreet: 'Discreetly Packaged',
  footer_ship_discreet_sub: 'No conspicuous labeling',
  footer_ship_contact: 'Personal Contact',
  footer_ship_contact_sub: 'Always reachable via WhatsApp',

  // ── Footer links ──
  footer_link_blueProtect: 'Blue Protect Series',
  footer_link_crystals: 'Crystals & Gemstones',
  footer_link_aroma: 'Aromatherapy',
  footer_link_chakra: 'Chakra Healing',
  footer_link_supp: 'Supplements',
  footer_link_selfcare: 'Self-Care',
  footer_link_about: 'About Us',
  footer_link_blog: 'Blog',
  footer_link_consult: 'Book Consultation',
  footer_link_reviews: 'Reviews & Experiences',
  footer_link_faq: 'Frequently Asked Questions',
  footer_link_orders: 'My Orders',
  footer_link_contact: 'Contact',
  footer_link_shipping: 'Shipping & Returns',

  // ── Language ──
  lang_nl: 'Nederlands',
  lang_en: 'English',
  lang_es: 'Español',

  // ── CTAs ──
  cta_planConsult: 'Book a consultation',
  cta_bookConsult: 'Book Consult',
  cta_discoverProtection: 'Discover your protection',
  cta_allProducts: 'View all protection products',
  cta_startToday: 'Start today',
  cta_viewProduct: 'View',
  cta_buyNow: 'Pay & Book Now',
  cta_learnMore: 'Learn more',
  cta_shopNow: 'Shop Now',
  cta_readMore: 'Read more',
  cta_back: 'Back',
  cta_subscribe: 'Subscribe',
  cta_bookNow: 'Book Now',
  cta_allArticles: 'All articles',
  cta_chooseProduct: 'Choose your Product',
  cta_askAdvice: 'Ask for Advice',
  cta_discoverSeries: 'Discover the Series',
  cta_inCart: 'Add to Cart',
  cta_addToCart: 'Add to Cart',
  cta_added: 'Added',
  cta_add: 'Add',
  cta_viewAllProducts: 'View all products',
  cta_bookConsultNow: 'Book Your Consultation',
  cta_sendMessage: 'Send Message',
  cta_sending: 'Sending...',
  cta_newMessage: 'New Message',
  cta_backToConsult: 'Back to Consultations',
  cta_inCartBtn: 'In Cart!',
  cta_addToCartBtn: 'Add to Cart',

  // ── Shop ──
  shop_title: 'Our Collection',
  shop_webshop_title: 'Blue Protect',
  shop_webshop_subtitle: 'Exclusive Blue Protect protection products',
  shop_filter_all: 'All Products',
  shop_filter_blue: 'Blue Protect Series',
  shop_filter_evil: 'Evil Energy Destroy',
  shop_filter_kit: 'Evil Energy Destroy Kit',
  shop_addToCart: 'Add to Cart',
  shop_inStock: 'In Stock',
  shop_outOfStock: 'Out of Stock',
  shop_perUnit: 'one-time',
  shop_reviews: 'reviews',
  shop_search_placeholder: 'Search products...',
  shop_sort_featured: 'Featured',
  shop_sort_price_asc: 'Price: Low to High',
  shop_sort_price_desc: 'Price: High to Low',
  shop_sort_rating: 'Highest Rating',
  shop_categories: 'Categories',
  shop_max_price: 'Max Price',
  shop_products_found: 'products found',
  shop_no_products: 'No products found',
  shop_cancelled_title: 'Payment cancelled',
  shop_cancelled_msg: 'You cancelled the payment. Your cart has been saved — you can try again at any time.',
  shop_blue_desc: 'Aura cleansing & spiritual protection — soap, balls, powder & spray.',
  shop_evil_desc: 'Strongest protection against evil energies, evil eye & spiritual attacks.',
  shop_kit_desc: 'Complete DIY kit for extreme cases — babies, new spaces & entities.',

  // ── Consultations ──
  consult_hero_badge: '✦ Personal Guidance ✦',
  consult_hero_title: 'Spiritual',
  consult_hero_title2: 'Consultations',
  consult_hero_sub: 'Personal energetic guidance and digital ritual blueprints for deep spiritual transformation.',
  consult_tab_book: 'Book Consultation',
  consult_tab_blueprints: 'Ritual Blueprints',
  consult_choose: 'Choose Your Consultation',
  consult_payment_title: 'Appointment & Payment',
  consult_form_first: 'First Name',
  consult_form_last: 'Last Name',
  consult_form_email: 'Email Address',
  consult_form_phone: 'Phone Number',
  consult_form_date: 'Preferred Date',
  consult_form_date_ph: 'Choose a date',
  consult_form_time: 'Time Preference',
  consult_form_msg: 'Your question or situation',
  consult_form_msg_ph: 'Briefly describe what you hope to discover or achieve...',
  consult_book_btn: 'Pay & Book Now',
  consult_success_title: 'Payment Successful!',
  consult_success_msg: 'You will receive a confirmation email within a few minutes. We will contact you to schedule the appointment.',
  consult_back: 'Back to Consultations',
  consult_stripe_info: 'Secure payment with Stripe',
  consult_stripe_desc: 'Pay directly by credit card or iDEAL. You will receive a confirmation email after payment.',
  consult_ssl: '256-bit SSL',
  consult_stripe_footer: 'Secure payment via Stripe · credit card & iDEAL',
  consult_select_first: 'Select a consultation type above',
  consult_selected: 'Selected',
  consult_most_chosen: 'Most Popular',
  consult_once: 'one-time',
  consult_add_cart: 'Add to Cart',
  consult_cart_safe: 'Checkout via cart · secure payment with Stripe',
  consult_avail_hint: 'Available on',
  consult_avail_and: '&',
  consult_no_avail: 'No availability',
  consult_no_avail_msg: 'No consultations on this day. Choose a Monday or Thursday.',
  consult_choose_date_first: 'Choose a date first to see available times',
  consult_digital_guides: '✦ Digital Guides ✦',
  consult_blueprints_title: 'Ritual Blueprints',
  consult_blueprints_sub: 'Complete digital guides for spiritual cleansing rituals. Instantly downloadable after purchase via Stripe.',
  consult_stripe_safe: 'Secure payment with Stripe',
  consult_stripe_safe_desc: 'After payment you will immediately receive a download link by email. Available via credit card and iDEAL.',
  consult_digital_guide: 'Digital Guide',
  consult_more_included: 'more included',
  consult_download_title: 'Instant Download After Payment',
  consult_download_desc: 'After successful payment via Stripe you will immediately receive an email with your download link. Blueprints are in PDF format and accessible for life.',
  consult_payment_success: 'Payment successful!',
  consult_payment_success_desc: 'Your download link has been sent to your email address. Also check your spam folder.',
  consult_reviews_badge: '✦ Experiences ✦',
  consult_reviews_title: 'What Clients',
  consult_reviews_title2: 'Say',
  consult_reviews_sub: 'Real experiences from people who took the step towards a consultation. No scripts, no filters.',
  consult_avg_rating: 'Average rating',
  consult_reviews_count: 'Reviews',
  consult_recommend: 'Would recommend',
  consult_ready: 'Ready to create your own experience?',

  // ── Blog ──
  blog_hero_badge: '✦ Shamanism & Spiritual Knowledge ✦',
  blog_hero_title: 'Protection for Yourself,',
  blog_hero_title2: 'Your Child and Your Environment',
  blog_hero_sub: 'Unrest, energy loss, a baby waking up at night — sometimes there\'s more going on than meets the eye. Discover proven shamanic protection knowledge for family, home and work.',
  blog_sticky_cta: 'Book a consultation',
  blog_recognize_badge: '✦ Do you recognize this? ✦',
  blog_recognize_title: 'Sometimes there\'s more going on than you can explain',
  blog_more: 'Read more?',
  blog_read_time: 'read time',

  // ── About ──
  about_badge: '✦ Our Story ✦',
  about_title: 'Rooted in',
  about_title2: 'Shamanic Traditions',
  about_sub: 'Personal guidance, authentic protection rituals and millennia-old knowledge — for everyone who wants to elevate their consciousness.',

  // ── Contact ──
  contact_badge: '✦ Get in Touch ✦',
  contact_title: 'Contact',
  contact_sub: 'Have a question or want to know more? We are here for you.',
  contact_info_title: 'Contact Information',
  contact_social_title: 'Follow Us on Social Media',
  contact_form_title: 'Send a Message',
  contact_form_first: 'First Name *',
  contact_form_last: 'Last Name *',
  contact_form_email: 'Email Address *',
  contact_form_subject: 'Subject *',
  contact_form_subject_ph: 'Select a subject',
  contact_form_subject_product: 'Product question',
  contact_form_subject_order: 'Order / Shipping',
  contact_form_subject_consult: 'Consultation information',
  contact_form_subject_collab: 'Collaboration',
  contact_form_subject_other: 'Other',
  contact_form_msg: 'Your message *',
  contact_form_msg_ph: 'How can we help you?',
  contact_form_max: 'Max. 500 characters',
  contact_success_title: 'Message Sent!',
  contact_success_msg: 'Thank you for your message. We will respond as soon as possible.',
  contact_error: 'Something went wrong. Please try again.',

  // ── FAQ ──
  faq_badge: 'Frequently Asked Questions',
  faq_title: 'Everything you want',
  faq_title2: 'to know',
  faq_sub: 'Answers to the most frequently asked questions about our products, rituals, orders and spiritual protection.',
  faq_questions_answered: 'Questions answered',
  faq_categories: 'Categories',
  faq_available: 'Available',
  faq_questions_in_cat: 'questions in this category',
  faq_not_found_title: 'Can\'t find your question?',
  faq_not_found_desc: 'Contact us directly by email or book a personal consultation — we are happy to help.',
  faq_send_message: 'Send a message',
  faq_book_consult: 'Book a consultation',

  // ── Home - FeaturedProducts ──
  home_bestsellers_badge: '✦ Bestsellers ✦',
  home_bestsellers_title: 'Bestsellers',

  // ── Home - SeriesSection ──
  home_series_badge: '✦ Our Series ✦',
  home_series_title: 'Choose Your',
  home_series_title2: 'Protection',
  home_series_sub: 'Two series, each for a different situation. From daily prevention to maximum protection against heavy spiritual attacks.',
  home_series_products: 'products',
  home_series_reviews: 'reviews',
  home_series_not_sure: 'Not sure which series suits you?',
  home_series_free_consult: 'Book a free consultation',
  home_series_help: 'and we will help you choose.',

  // ── Home - CTASection ──
  home_cta_discover_badge: '✦ Discover Yourself ✦',
  home_cta_discover_title: 'Find Your Inner Balance',
  home_cta_discover_sub: 'Bring body and mind into harmony',
  home_cta_blueprint_badge: '✦ Personal Growth Plan ✦',
  home_cta_blueprint_title: 'Your Spiritual',
  home_cta_blueprint_title2: 'Blueprint',
  home_cta_blueprint_sub: 'Book a personal consultation or download our digital ritual blueprints and start transforming your energetic life today.',
  home_cta_book_consult: 'Book a Consultation Now',
  home_cta_blueprints: 'Ritual Blueprints',

  // ── Home - TestimonialsSection ──
  home_test_badge: '✦ Experiences ✦',
  home_test_title: 'What Clients Say About',
  home_test_sub: 'Real experiences from clients who experience the power of pure blue extract from our ancestral tradition daily.',
  home_test_stat1: 'Satisfied customers',
  home_test_stat2: 'Average rating',
  home_test_stat3: 'Repeat purchases',
  home_test_stat4: 'Years of tradition',

  // ── Home - FeaturedCategories ──
  home_cat_badge: '✦ Collections ✦',
  home_cat_title: 'Discover Our',
  home_cat_title2: 'Collections',
  home_cat_new: 'New',

  // ── Home - BlogPreview ──
  home_blog_badge: '✦ Blog ✦',
  home_blog_title: 'Spiritual',
  home_blog_title2: 'Insights',

  // ── Home - InstagramSection ──
  home_insta_title: 'Follow us on',
  home_insta_title2: 'Instagram',
  home_insta_sub: 'Daily rituals, product tips and spiritual inspiration. Tag us with',
  home_insta_sub2: 'and get featured!',
  home_insta_hashtags_title: 'Use these hashtags',
  home_insta_hashtags_sub: '— expand your reach',
  home_insta_copy_all: 'Copy all hashtags',
  home_insta_copied: 'All copied!',
  home_insta_copied_tag: 'Copied!',
  home_insta_follow: 'Follow @zpiritualz',
  home_insta_ugc: 'customers shared their experience — tag us and get featured on our page!',

  // ── Home - TikTokSection ──
  home_tiktok_title: 'Follow us on',
  home_tiktok_title2: 'TikTok',
  home_tiktok_sub: 'Daily rituals, product demos and spiritual tips. Join our growing community of',
  home_tiktok_sub2: 'followers protecting their energy.',
  home_tiktok_followers: 'Followers',
  home_tiktok_likes: 'Likes',
  home_tiktok_views: 'Views',
  home_tiktok_no_miss: 'Don\'t miss a single ritual',
  home_tiktok_no_miss_sub: 'New videos every week about spiritual protection, product demos and rituals. Follow us now and turn on notifications!',
  home_tiktok_follow: 'Follow @zpiritualz.com',
  home_tiktok_notify: 'Turn on notifications',

  // ── Blue Protect page ──
  bp_cultural_badge: '✦ Origin & Culture ✦',
  bp_cultural_title: 'Ancient use,',
  bp_cultural_title2: 'modern form',
  bp_cultural_desc1: 'Blue powder has been used for thousands of years in Surinamese and other world cultures for protection against the evil eye — Ogri Ai in Surinamese, Nazar among Hindustanis, Azul in the Spanish tradition.',
  bp_cultural_desc2: 'Blue Protect preserves this heritage in its purest form. The indigo extract is obtained exactly as our ancestors did — by hand, without chemical processing steps, with respect for tradition.',
  bp_heritage: 'Surinamese Heritage',
  bp_test_badge: '✦ Experiences ✦',
  bp_test_title: 'What Clients',
  bp_test_title2: 'Say',
  bp_cross_badge: 'For heavier cases',
  bp_cross_title: 'Also discover the',
  bp_cross_title2: 'Evil Energy Destroy Series',
  bp_cross_title3: '?',
  bp_cross_desc: 'For heavy spiritual attacks, persistent evil energies or repeated exposure — the Evil Energy Destroy Series is our most powerful formula.',
  bp_cross_btn: 'View Evil Energy Protect',
  bp_cta_badge: '✦ Start Today ✦',
  bp_cta_title: 'Your Protection',
  bp_cta_title2: 'Starts Here',
  bp_cta_sub: 'Step into an ancient protection tradition. Pure, authentic and powerful — exactly as our ancestors intended.',
  bp_cta_choose: 'Choose your Product',
  bp_cta_advice: 'Ask for Advice',
  bp_cta_pure: '100% Pure Indigo Extract',
  bp_cta_fast: 'Fast Shipping',
  bp_cta_safe: 'Secure Ordering',
  bp_nav_products: 'Products',
  bp_nav_rituals: 'Rituals',
  bp_nav_ingredients: 'Ingredients',

  // ── Evil Energy page ──
  ee_test_badge: '✦ Experiences ✦',
  ee_test_title: 'What Clients',
  ee_test_title2: 'Say',
  ee_cta_badge: '✦ Ready for Protection ✦',
  ee_cta_title: 'Your Protection',
  ee_cta_title2: 'Starts Today',
  ee_cta_sub: 'Don\'t wait until the situation gets worse. The Evil Energy Destroy Series is ready to protect you with the power of ancient traditions and the purest ingredients.',
  ee_cta_choose: 'Choose your Product',
  ee_cta_advice: 'Ask for Advice',
  ee_cta_pure: '100% Pure Natural',
  ee_cta_fast: 'Fast Shipping',
  ee_cta_safe: 'Secure Ordering',
  ee_nav_products: 'Products',
  ee_nav_bundle: 'Ritual Bundle',
  ee_nav_rituals: 'Rituals',
  ee_nav_ingredients: 'Ingredients',

  // ── About page ──
  about_hero_title: 'The Power Behind ZpiritualZ',
  about_founded: 'Founded',
  about_tradition: 'Years of tradition',
  about_households: 'Protected households',
  about_story_badge: '✦ How It Started ✦',
  about_story_title: 'A Personal Experience That Changed Everything',
  about_story_p1: 'ZpiritualZ was not born from a spreadsheet or a marketing plan — it was born from a personal crisis. After a period of persistent negativity, unrest at home and a feeling that something was off in the energy of the environment, the founder returned to what her grandmother had taught her: burning hing, hing under the pillow, hing in the bath water.',
  about_story_p2: 'The change was palpable. Not as magic — but as recognition. Like coming home to knowledge that had always been present in the family, but passed down for generations without explanation. ZpiritualZ was founded to give that knowledge back to everyone who needs it.',
  about_story_p3: 'Today we translate ancient shamanic protection traditions into products that fit into daily life: in the bathroom, in the bedroom, in the nursery — everywhere protection is needed.',
  about_ingredient_label: 'Key Ingredient',
  about_ingredient_name: 'Ferula asafoetida',
  about_ingredient_sub: 'Pure hing extract · Iranian & Indian',
  about_sham_origin: '✦ The Origin of Everything ✦',
  about_sham_title: 'Shamanism is the Source',
  about_sham_desc: 'Shamanism is one of the oldest spiritual practices in the world, rooted in indigenous traditions and cultures worldwide. Shamans are the bridge builders between the visible and invisible world — the protectors, healers and guides of their community.',
  about_sham_worldwide: 'Present worldwide',
  about_sham_worldwide_desc: 'From Siberia to the Amazon, from West Africa to Oceania — shamanism is the universal spiritual language of humanity.',
  about_sham_age: '40,000+ years old',
  about_sham_age_desc: 'Older than all organized religions. The roots of shamanism reach back to the first humans who made fire and studied the stars.',
  about_sham_plants: 'Plants as the key',
  about_sham_plants_desc: 'Sacred plants and resins — such as hing, sage and lobhan — are the shaman\'s instruments for cleansing, protection and healing.',
  about_sham_caption: 'Shamanism · Global Wisdom',
  about_sham_caption_sub: 'Every culture, every continent — the shaman is universally present as protector of the community.',
  about_hing_badge: '✦ The Origin ✦',
  about_hing_title: 'The Hing Tradition: 2,000 Years of Protection',
  about_hing_sub: 'Hing — the resin of the Ferula asafoetida plant — is one of the oldest spiritual and medicinal raw materials in the world. From Iran to India, from India to Suriname, from Suriname to the Netherlands.',
  about_hing_origin: 'From Iran & India',
  about_hing_origin_desc: 'Ferula asafoetida grows in the deserts of Central Asia. The resin has been used for more than 2,000 years in Persian, Indian and Surinamese traditions.',
  about_hing_protector: 'Protector of the Home',
  about_hing_protector_desc: 'In Hindustani households, hing has been used for generations to protect the home, the baby and the bedroom against the evil eye and negative energies.',
  about_hing_smoke: 'Cleansed by Smoke',
  about_hing_smoke_desc: 'Burning hing as incense cleanses the energy of a space. The scent penetrates every corner and drives away what does not belong in the space.',
  about_hing_baby: 'Protection of the Baby',
  about_hing_baby_desc: 'For centuries, hing paste has been applied to the hair of newborns or placed under the pillow — a loving ritual passed from mother to child.',
  about_hing_quote: '"Hing is never lost — it travels. From the Indian highlands to the Surinamese savannas, from the savannas to the Dutch neighborhoods. The knowledge lives."',
  about_hing_journey: 'The Journey of Hing Through the World',
  about_timeline_badge: '✦ Timeline ✦',
  about_timeline_title: 'From Ancient Tradition to Modern Brand',
  about_philosophy_badge: '✦ Philosophy ✦',
  about_philosophy_title: 'What We Believe',
  about_philosophy_sub: 'ZpiritualZ is more than a product line — it is a philosophy of protection, consciousness and cultural heritage.',
  about_phil_roots: 'Respecting Roots',
  about_phil_roots_desc: 'Our products were not invented — they were rediscovered. We bring the wisdom of ancestors back to the modern world without losing the essence.',
  about_phil_pure: 'Pure & Undiluted',
  about_phil_pure_desc: 'No cheap fillers. No synthetic masks. Every product contains a fair percentage of pure hing extract, as tradition prescribes.',
  about_phil_sham: 'Shamanic Knowledge',
  about_phil_sham_desc: 'Shamanism is one of the oldest spiritual practices in the world — rooted in indigenous traditions and cultures worldwide. ZpiritualZ draws from this timeless source.',
  about_phil_ritual: 'Rituals for Everyone',
  about_phil_ritual_desc: 'Whether you are a new mother, looking for home cleansing or simply want protection — our products are accessible and practical for daily use.',
  about_quote: '"Every product we make is a prayer. A reminder of what our ancestors knew: that protection begins with scent, with intention, with ritual."',
  about_cta_badge: '✦ Discover the Products ✦',
  about_cta_title: 'Ready to Protect Your Home?',
  about_cta_sub: 'Discover our Evil Energy Destroy Series — six products based on pure hing extract, for daily protection at home, for baby and for space.',
  about_cta_ee: 'Evil Energy Destroy Series',
  about_cta_shop: 'All Products',

  // ── Contact page ──
  contact_address: 'Address',
  contact_email_label: 'Email',
  contact_hours: 'Opening Hours',
  contact_reach: 'Availability',
  contact_address_val: 'Kobaltstraat 21, 2544 ET The Hague, Netherlands',
  contact_email_val: 'info@zpiritualz.com',
  contact_hours_val: 'Mon–Sat: 10:00–17:00',
  contact_reach_val: 'We are only reachable by email',
  contact_map_title: 'ZpiritualZ location The Hague',
  contact_form_ph_first: 'Luna',
  contact_form_ph_last: 'Smith',
  contact_form_ph_email: 'you@email.com',
  contact_form_ph_msg: 'How can we help you?',

  // ── FAQ page ──
  faq_cat_general: 'General',
  faq_cat_blue: 'Blue Protect Series',
  faq_cat_evil: 'Evil Energy Destroy Series',
  faq_cat_kit: 'Evil Energy Destroy Kit',
  faq_cat_blueprints: 'Ritual Blueprints',
  faq_cat_consult: 'Consultations',
  faq_questions_in_cat_label: 'questions in this category',

  // ── Shop page ──
  shop_hero_title: 'Blue Protect',
  shop_hero_subtitle: 'Webshop',
  shop_hero_desc: 'Exclusive Blue Protect protection products',
  shop_filter_label: 'Categories',
  shop_price_label: 'Max Price',
  shop_in_stock: 'In stock',
  shop_cancelled_close: 'Close',

  // ── Blue Protect Hero ──
  bp_hero_badge: 'Ancient Protection',
  bp_hero_title: 'Blue Protect Series',
  bp_hero_sub: 'Based on an ancient use of blue powder for spiritual protection — rooted in Surinamese culture and recognized worldwide.',
  bp_hero_pure: 'Pure indigo extract, exactly as our ancestors used it. No synthetic additives. Ever.',
  bp_hero_surinamese: 'Surinamese',
  bp_hero_hindustani: 'Hindustani',
  bp_hero_spanish: 'Spanish',
  bp_hero_view_products: 'View Products',
  bp_hero_discover: 'Discover the Formula',
  bp_hero_stat1: 'Products in the Series',
  bp_hero_stat2: 'Average Rating',
  bp_hero_stat3: 'Customer Reviews',
  bp_hero_stat4: 'Pure Indigo Extract',

  // ── Blue Protect Ingredients ──
  bp_ing_badge: '✦ Pure from Nature ✦',
  bp_ing_title: 'The Ingredients',
  bp_ing_sub: 'Every ingredient in the Blue Protect Series is purely derived from nature — exactly as our ancestors used it for centuries, without chemical processes.',
  bp_ing_promise_badge: 'Our Promise',
  bp_ing_promise_title: 'Only pure indigo extract. No synthetic imitations. Ever.',
  bp_ing_promise_desc: 'Many competitors use synthetic blue dyes as a cheap alternative. We refuse this. Our blue comes exclusively from the indigo plant — just as it is obtained at the source.',
  bp_ing_name: 'Pure Indigo Extract',
  bp_ing_latin: 'Indigofera tinctoria',
  bp_ing_desc: 'The heart of the Blue Protect formula. Indigofera is a sacred plant that has been used for thousands of years in spiritual protection rituals worldwide. The deep blue extract is obtained directly from the plant — pure, unfiltered and unprocessed.',
  bp_ing_origin: 'South Asia & West Africa — the oldest known protective dye in the world',
  bp_ing_found_in: 'Present in all products',
  bp_ing_balls_badge: '✦ Unique Feature ✦',
  bp_ing_balls_title: 'Blue Protect Balls — Dissolving is the Power',
  bp_ing_balls_sub: 'What makes the Balls unique compared to the other products in the series: they are specially made to dissolve in water. This releases the extract completely — in the bath or as a protective glass in the corners of your space.',
  bp_ing_balls_f1_title: 'Dissolves completely in water',
  bp_ing_balls_f1_desc: 'The ball slowly dissolves and gradually releases the pure indigo extract — in the bath or in a glass of water.',
  bp_ing_balls_f2_title: 'Glass of water in the corners',
  bp_ing_balls_f2_desc: 'Place a dissolved ball in a glass of water with a dash of Evil Energy Destroy Cologne and place in the corners of rooms for constant protection.',
  bp_ing_balls_f3_title: 'Deep bath cleansing',
  bp_ing_balls_f3_desc: 'Dissolve a ball in warm bath water for a deep energetic cleansing of the entire body — the extract spreads evenly through the water.',
  bp_ing_balls_f4_title: '100% pure and natural',
  bp_ing_balls_f4_desc: 'No synthetic binders or fillers — the ball consists exclusively of pure indigo extract that dissolves completely without residue.',
  bp_ing_how_badge: 'How it works',
  bp_ing_how_title: 'As soon as the ball comes into contact with water, the indigo extract begins to release — the water turns deep blue and is ready for use.',
  bp_ing_how_f1: 'Completely soluble — no residue',
  bp_ing_how_f2: 'Works in the bath and in a glass of water',
  bp_ing_how_f3: 'Combine with Evil Energy Destroy Cologne',

  // ── Blue Protect Products ──
  bp_prod_badge: '✦ The Collection ✦',
  bp_prod_title: '4 Products, 1 Mission',
  bp_prod_sub: 'Each formula in the Blue Protect Series is aimed at a specific application method — together they form a complete spiritual protection layer.',
  bp_prod_series: 'Blue Protect Series',
  bp_prod_in_stock: 'In stock',
  bp_prod_tab_desc: 'Description',
  bp_prod_tab_ing: 'Ingredients',
  bp_prod_tab_use: 'How to Use',
  bp_prod_tab_reviews: 'Reviews',
  bp_prod_ing_title: 'Ingredients',
  bp_prod_ing_pure: 'All ingredients are 100% pure in origin — no synthetic additives, fillers or chemical derivatives.',
  bp_prod_use_title: 'Instructions for Use',
  bp_prod_overview: 'Full Series Overview',
  bp_prod_add_cart: 'Add to Cart',

  // ── Blue Protect Rituals ──
  bp_rit_badge: '✦ Sacred Practices ✦',
  bp_rit_title: 'Protection Rituals',
  bp_rit_sub: 'The Blue Protect products are most powerful when applied consciously as a ritual — exactly as our ancestors did for generations.',
  bp_rit_duration: 'Duration',
  bp_rit_level: 'Level',
  bp_rit_products: 'Required Products',
  bp_rit_steps: 'Step by step',
  bp_rit_tip: 'Tip',
  bp_rit1_title: 'Daily Aura Cleansing',
  bp_rit1_sub: 'Preventive morning routine',
  bp_rit1_duration: '8 minutes',
  bp_rit1_level: 'Beginners',
  bp_rit1_tip: 'Use this ritual every morning as prevention, even if you have no direct complaints.',
  bp_rit2_title: 'Spiritual Cleansing Bath',
  bp_rit2_sub: 'Deep energetic reset',
  bp_rit2_duration: '30–40 minutes',
  bp_rit2_level: 'Beginner',
  bp_rit2_tip: 'Do this ritual preferably on Friday or at the full moon for maximum cleansing effect.',
  bp_rit3_title: 'Home Cleansing Ritual',
  bp_rit3_sub: 'Protect your home completely',
  bp_rit3_duration: '15–20 minutes',
  bp_rit3_level: 'Beginners',
  bp_rit3_tip: 'Repeat this ritual weekly, or immediately after conflicts or many visitors.',
  bp_rit4_title: 'Protection of the Vulnerable',
  bp_rit4_sub: 'For children & pregnant women',
  bp_rit4_duration: '5 minutes',
  bp_rit4_level: 'Beginners',
  bp_rit4_tip: 'Children and pregnant women are according to tradition most vulnerable to the evil eye. Regular protection is essential.',

  // ── Evil Energy Hero ──
  ee_hero_badge: 'Maximum Protection',
  ee_hero_title: 'Evil Energy Destroy Series',
  ee_hero_sub: 'For those dealing with heavy spiritual attacks, persistent evil energies or repeated exposure to the evil eye — when ordinary protection is no longer sufficient.',
  ee_hero_pure: 'Based on the heaviest protection recipe of our ancestors. Pure, powerful, uncontaminated.',
  ee_hero_view: 'View Products',
  ee_hero_discover: 'Discover the Formula',
  ee_hero_stat1: 'Products in the Series',
  ee_hero_stat2: 'Average Rating',
  ee_hero_stat3: 'Customer Reviews',
  ee_hero_stat4: 'Pure Hing Extract',

  // ── Evil Energy Ingredients ──
  ee_ing_badge: '✦ The Key Ingredient ✦',
  ee_ing_title: 'The Power of Hing',
  ee_ing_sub: 'All six products in the Evil Energy Destroy Series are built around one powerful key ingredient: pure hing extract (Ferula asafoetida) — the strongest repellent that nature knows.',
  ee_ing_promise_badge: 'Our Promise',
  ee_ing_promise_title: 'Pure hing. Nothing else. No synthetic imitations. Ever.',
  ee_ing_promise_desc: 'While many other brands use cheap synthetic fragrances as a substitute, we refuse this. Our hing is 100% purely derived from the root of the Ferula asafoetida plant — exactly as our ancestors used it.',
  ee_ing_name: 'Hing (Asafoetida)',
  ee_ing_latin: 'Ferula asafoetida',
  ee_ing_desc: 'Hing — also known as devil\'s dung or asafoetida — is the most powerful repellent in the Surinamese, Hindustani and South Asian protection tradition. The sharp, penetrating scent of hing is capable of directly driving away evil spirits, negative intentions and the evil eye. Where hing is present, evil cannot thrive.',
  ee_ing_origin: 'Iran, Afghanistan & India — used for thousands of years as a sacred protective agent in multiple world cultures',
  ee_ing_found_in: 'Present in all 6 products',
  ee_ing_surinamese: 'Surinamese tradition',
  ee_ing_surinamese_text: 'In Surinamese culture, hing has been used for generations to protect babies and the vulnerable. A little hing in the hair or under the pillow of a baby keeps the evil eye away.',
  ee_ing_hindustani: 'Hindustani tradition',
  ee_ing_hindustani_text: 'Hing — also known as "heeng" or "inguva" — is used in Hindustani protection rituals to drive away evil spirits and negative energies. Burning hing completely cleanses a space.',
  ee_ing_worldwide: 'Global recognition',
  ee_ing_worldwide_text: 'From the Middle East to Central Asia: hing is recognized in multiple cultures as one of the most powerful repellents that nature knows. The scent alone drives away evil.',

  // ── Evil Energy Rituals ──
  ee_rit_badge: '✦ Sacred Practices ✦',
  ee_rit_title: 'Protection Rituals',
  ee_rit_sub: 'Each product in the Evil Energy Destroy Series has its own application ritual. Combine them for complete, multi-layered protection of body and home.',
  ee_rit_duration: 'Duration',
  ee_rit_level: 'Level',
  ee_rit_products: 'Required Products',
  ee_rit_steps: 'Step by step',
  ee_rit_tip: 'Tip',
  ee_rit1_title: 'Daily Bath Ritual',
  ee_rit1_sub: 'Protection of body & aura',
  ee_rit1_duration: '15–20 minutes',
  ee_rit1_level: 'Beginners',
  ee_rit1_tip: 'Use every day for continuous protection. For severe cases: twice daily.',
  ee_rit2_title: 'Baby Protection',
  ee_rit2_sub: 'Safe day & night for your little one',
  ee_rit2_duration: '2 minutes',
  ee_rit2_level: 'Beginners',
  ee_rit2_tip: 'Repeat every day. After visits from many people or in busy environments: apply immediately upon returning home.',
  ee_rit3_title: 'Home Cleansing Ritual',
  ee_rit3_sub: 'Drive evil energies from every room',
  ee_rit3_duration: '20–30 minutes',
  ee_rit3_level: 'Beginners',
  ee_rit3_tip: 'Do this weekly or immediately after visits from people who bring a heavy atmosphere.',
  ee_rit4_title: 'Candle & Diffuser Ritual',
  ee_rit4_sub: 'Continuous protection through scent and light',
  ee_rit4_duration: '5 minutes preparation',
  ee_rit4_level: 'Beginners',
  ee_rit4_tip: 'Burning hing oil in the bedroom also protects during sleep. Never use without supervision.',
  ee_rit5_title: 'Mopping the House',
  ee_rit5_sub: 'Building protection from the ground up',
  ee_rit5_duration: '20 minutes',
  ee_rit5_level: 'Beginners',
  ee_rit5_tip: 'Weekly mopping with Cologne keeps the house continuously protected. Ideal as a supplement to the incense ritual.',

  // ── Evil Energy Bundle ──
  ee_bundle_badge: '✦ Recommended Combination ✦',
  ee_bundle_title: 'The Daily Ritual Bundle',
  ee_bundle_sub: 'For maximum protection, combine the Evil Energy Destroy Soap with the Cologne in one daily bath ritual. Together they form a complete energetic cleansing cycle that actively breaks, destroys and carries away evil energy.',
  ee_bundle_step1: 'Step 1',
  ee_bundle_step2: 'Step 2',
  ee_bundle_ritual_title: 'The Daily Bath Ritual',
  ee_bundle_ritual_sub: 'Step-by-step complete protection cycle',
  ee_bundle_ritual_note: 'Important ritual detail',
  ee_bundle_ritual_note_desc: 'Throw the bottle backwards without looking back. Turning around to look breaks the energetic transfer and can reduce the protection. Perform the ritual preferably in the morning for a day full of protection.',
  ee_bundle_cta_badge: 'Recommended Daily Package',
  ee_bundle_cta_title: 'Soap + Cologne Bundle',
  ee_bundle_cta_sub: 'Both products together — complete for the daily ritual',
  ee_bundle_label: 'Bundle',
  ee_bundle_add: 'Add Bundle to Cart',
  ee_bundle_all: 'View All Products',
  ee_bundle_pure: '100% Pure Natural',
  ee_bundle_daily: 'Daily Use',
  ee_bundle_proven: 'Proven Ritual',
  ee_bundle_step1_title: 'Fill the bath',
  ee_bundle_step1_desc: 'Fill the bath with warm water and add a generous splash of Evil Energy Destroy Cologne to the bath water. Stir with your hand three times clockwise.',
  ee_bundle_step2_title: 'Wash the body',
  ee_bundle_step2_desc: 'Wash your body with the Evil Energy Destroy Soap. Let the mixture of cologne and soap flow over your entire body.',
  ee_bundle_step3_title: 'Collect the mixture',
  ee_bundle_step3_desc: 'Collect the water that has flowed over your body in an empty bottle. This water has absorbed the evil energies.',
  ee_bundle_step4_title: 'Add 5 cents',
  ee_bundle_step4_desc: 'Add a 5 cent coin to the bottle and close it tightly. The coin strengthens the transfer of negative energy.',
  ee_bundle_step5_title: 'Bottle in the sea',
  ee_bundle_step5_desc: 'Throw the bottle backwards into the sea — without looking back. The sea water carries the evil energies away permanently.',

  // ── EDK Hero ──
  edk_hero_badge: 'Extreme Cases · DIY Kit',
  edk_hero_title: 'Evil Energy Destroy Kit Complete!',
  edk_hero_sub: 'For the most severe cases — when cleaning a space is not enough and the evil energy must be destroyed. A complete package with everything you need.',
  edk_hero_pure: 'Including professional Blueprint · Special herbal incense mix · Complete ritual materials',
  edk_hero_complete: 'Complete package',
  edk_hero_discover: 'Discover When You Need This',
  edk_hero_stat1: 'Items in the Package',
  edk_hero_stat2: 'Situations Covered',
  edk_hero_stat3: 'Pure Natural',
  edk_hero_stat4: 'Average Rating',
  edk_hero_added: 'Added to cart!',
  edk_hero_add: 'Add to Cart',

  // ── EDK Contents ──
  edk_contents_badge: '✦ What\'s in the Package? ✦',
  edk_contents_title: 'The Complete Arsenal',
  edk_contents_sub: 'Everything you need to destroy evil energies. Carefully assembled by ZpiritualZ — nothing more needed, nothing less.',
  edk_contents_summary: '10 Items · 1 Complete Kit',
  edk_contents_summary_sub: 'Everything you need for the destruction ritual',
  edk_contents_blueprint_title: 'Blueprint Included',
  edk_contents_blueprint_sub: 'The secret guide — exclusive with this package',
  edk_contents_blueprint_p1: 'Without the right knowledge, the best materials are nothing. The Blueprint is the guide that leads you step by step through the complete destruction ritual. Which order, which material at which moment, which intention you set.',
  edk_contents_blueprint_p2: 'The Blueprint was exclusively developed by ZpiritualZ and is only available as part of the Destroy Kit. You receive it immediately upon purchase.',
  edk_contents_pure: '100% Pure Natural',
  edk_contents_no_synth: 'No Synthetic Additives',
  edk_contents_ancient: 'Ancient Formula',
  edk_contents_guaranteed: 'ZpiritualZ Guaranteed',

  // ── EDK Problems ──
  edk_prob_badge: '✦ Who Is This Package For? ✦',
  edk_prob_title: 'Do You Recognize Your Situation?',
  edk_prob_sub: 'The Destroy Kit was developed for three specific, serious situations. Read which one most resembles your situation.',
  edk_prob_symptoms: 'Recognizable Signs',
  edk_prob_order: 'Order the Destroy Kit',

  // ── EDK Purchase ──
  edk_purch_test_badge: '✦ Experiences ✦',
  edk_purch_test_title: 'What Our Customers Say',
  edk_purch_cta_badge: '✦ Do It Now ✦',
  edk_purch_cta_title: 'Destroy The Evil Energy Forever',
  edk_purch_cta_sub: 'Stop accepting what you don\'t have to accept. With the right knowledge and materials, you can handle this yourself — today.',
  edk_purch_kit_name: 'Evil Energy Destroy Kit Complete',
  edk_purch_includes: 'Including Blueprint, Herbal Mix & Complete Ritual Set',
  edk_purch_blueprint: 'Blueprint Included',
  edk_purch_herbs: 'Special Herbal Mix',
  edk_purch_shell: 'Abalone Shell + Feather',
  edk_purch_coal: 'Charcoal + Candle',
  edk_purch_added: 'Added to cart!',
  edk_purch_add: 'Add to Cart',
  edk_purch_pure: '100% Pure Natural',
  edk_purch_fast: 'Fast Shipping',
  edk_purch_worldwide: 'Worldwide Shipping',
  edk_purch_guarantee: 'ZpiritualZ Guarantee',
  edk_purch_safe: 'Secure payment via Stripe · credit card & iDEAL',

  // ── BPProducts ──
  bp_prod_in_stock_label: 'In stock',
  bp_prod_add_cart_btn: 'Add to Cart',
  bp_prod_ing_label: 'Ingredients',
  bp_prod_use_label: 'How to Use',
  bp_prod_series_label: 'Blue Protect Series',
  bp_prod_overview_label: 'Full Series Overview',
  bp_prod_ing_pure_note: 'All ingredients are 100% pure in origin — no synthetic additives, fillers or chemical derivatives.',

  // ── EDKContents ──
  edk_cont_badge: '✦ What\'s in the Package? ✦',
  edk_cont_title: 'The Complete Arsenal',
  edk_cont_sub: 'Everything you need to destroy evil energies. Carefully assembled by ZpiritualZ — nothing more needed, nothing less.',
  edk_cont_summary: '10 Items · 1 Complete Kit',
  edk_cont_summary_sub: 'Everything you need for the destruction ritual',
  edk_cont_old_price: '€99.95',
  edk_cont_price: '€79.95',
  edk_cont_blueprint_title: 'Blueprint Included',
  edk_cont_blueprint_sub: 'The secret guide — exclusive with this package',
  edk_cont_blueprint_p1: 'Without the right knowledge, the best materials are nothing. The Blueprint is the guide that leads you step by step through the complete destruction ritual. Which order, which material at which moment, which intention you set.',
  edk_cont_blueprint_p2: 'The Blueprint was exclusively developed by ZpiritualZ and is only available as part of the Destroy Kit. You receive it immediately upon purchase.',
  edk_cont_pure: '100% Pure Natural',
  edk_cont_no_synth: 'No Synthetic Additives',
  edk_cont_ancient: 'Ancient Formula',
  edk_cont_guaranteed: 'ZpiritualZ Guaranteed',
  edk_cont_item1_name: 'Exclusive Blueprint',
  edk_cont_item1_desc: 'Step-by-step guide from ZpiritualZ for the complete destruction ritual. Which steps, in which order, with which material. Nothing left to chance.',
  edk_cont_item1_tag: 'Included',
  edk_cont_item2_name: 'Special Herbal Incense Mix',
  edk_cont_item2_desc: 'Our exclusive mix of sage herb extracts, ghandak, pepper, hing and lobhan. A reliable proprietary formula with proven effectiveness — particularly powerful for destroying evil energies.',
  edk_cont_item2_tag: 'Own Mix',
  edk_cont_item3_name: 'Sage Herb Extracts',
  edk_cont_item3_desc: 'Purely dried sage — the most widely used cleansing herb in the world. Cleanses the aura and space of all negative energy after burning.',
  edk_cont_item3_tag: 'Herb',
  edk_cont_item4_name: 'Ghandak (Sulfur)',
  edk_cont_item4_desc: 'One of the oldest and most powerful protective agents. Ghandak destroys persistent evil energies and entities that survive other cleansing agents.',
  edk_cont_item4_tag: 'Destructive',
  edk_cont_item5_name: 'Pepper & Hing',
  edk_cont_item5_desc: 'Black pepper combines with hing (asafoetida) for a double line of protection. Together they form an energetic wall that repels and destroys negative influences.',
  edk_cont_item5_tag: 'Double Power',
  edk_cont_item6_name: 'Lobhan (Benzoin)',
  edk_cont_item6_desc: 'Traditional Arabic-Surinamese cleansing resin. Lobhan cleanses deeply on a spiritual level and protects the space after the cleansing ritual.',
  edk_cont_item6_tag: 'Resin',
  edk_cont_item7_name: 'Abalone Shell',
  edk_cont_item7_desc: 'The sacred bowl for burning your incense. The abalone shell protects your hands and amplifies the energy of the smoke that rises during the ritual.',
  edk_cont_item7_tag: 'Ritual',
  edk_cont_item8_name: 'Owl Feather',
  edk_cont_item8_desc: 'A powerful ritual instrument. The owl feather spreads the sacred smoke through the space and is considered a powerful protective symbol in many spiritual traditions.',
  edk_cont_item8_tag: 'Ritual',
  edk_cont_item9_name: 'Charcoal',
  edk_cont_item9_desc: 'Special charcoal for burning your incense mix. Charcoal ensures an even, long-lasting burn so the power of the herbs is fully released.',
  edk_cont_item9_tag: 'Burning',
  edk_cont_item10_name: 'White Candle',
  edk_cont_item10_desc: 'Pure white candle to strengthen the intention of the ritual and symbolize light against darkness. Illuminates your ritual and attracts positive energy.',
  edk_cont_item10_tag: 'Light',

  // ── EDKProblems ──
  edk_prob_badge: '✦ Who Is This Package For? ✦',
  edk_prob_title: 'Do You Recognize',
  edk_prob_title2: 'Your Situation?',
  edk_prob_sub: 'The Destroy Kit was developed for three specific, serious situations. Read which one most resembles your situation.',
  edk_prob_symptoms_label: 'Recognizable Signs',
  edk_prob_order_btn: 'Order the Destroy Kit — €79.95',
  edk_prob1_tag: 'Baby & Nurseries',
  edk_prob1_title: 'Your Baby Wakes Up Frightened Every Night',
  edk_prob1_sub: 'Unrest, fear and tears without reason',
  edk_prob1_p1: 'It started with one night. Then two. Then the same pattern every night — your little one cries, wakes up frightened, stares at a corner of the room as if it sees something there. You\'ve tried everything. New pacifier, soft music, more cuddles. Nothing helps.',
  edk_prob1_p2: 'What most parents don\'t know: babies and young children are extremely sensitive to energies. They feel what adults can no longer feel. When a baby repeatedly wakes up frightened, cries or refuses to sleep in a certain room, that is in many traditions a sign that the space is negatively charged.',
  edk_prob1_p3: 'The Evil Energy Destroy Kit is specially designed for these cases. The herbal incense mix with sage, ghandak and hing cleanses the room on an energetic level. The Blueprint explains step by step how to completely clear the room — so your little one can finally sleep peacefully again.',
  edk_prob1_s1: 'Baby repeatedly wakes up frightened at the same time',
  edk_prob1_s2: 'Looks fearfully at the same corner or spot in the room',
  edk_prob1_s3: 'Restless sleep without medical cause',
  edk_prob1_s4: 'Suddenly changed behavior after moving',
  edk_prob2_tag: 'New Home or Business',
  edk_prob2_title: 'A New Beginning Deserves a Clean Slate',
  edk_prob2_sub: 'Destroying negative energy from the past',
  edk_prob2_p1: 'Everyone who lived or worked in that house or business before you has left their energy behind. Arguments. Grief. Jealousy. Financial worries. Failure. That energy clings to the walls, the floors, the thresholds — and it waits for the next occupant. For you.',
  edk_prob2_p2: 'In many cultures, cleansing a new space is a sacred ritual before moving in. Not without reason. When you start a new business in a space where a previous entrepreneur went bankrupt, you take on their energetic legacy. When you move into a house where tensions prevailed, you sometimes feel that immediately — a heavy feeling, no energy, things not working out.',
  edk_prob2_p3: 'The Destroy Kit gives you everything you need to completely destroy that old energy and recharge your space. The abalone shell, owl feather and the complete incense mix together provide a deep space cleansing. The Blueprint explains the ritual from A to Z.',
  edk_prob2_s1: 'Persistent heavy feeling in the new space',
  edk_prob2_s2: 'Businesses or projects that just won\'t get off the ground',
  edk_prob2_s3: 'Constant setbacks from the moment of moving in',
  edk_prob2_s4: 'Feeling that the energy of the previous occupant is still there',
  edk_prob3_tag: 'Presence of an Entity',
  edk_prob3_title: 'You Are Not Alone — And You Know It',
  edk_prob3_sub: 'For those who sense a presence',
  edk_prob3_p1: 'It starts subtly. A feeling of being watched. Shadows in the corner of your eye. Sounds you can\'t explain. You wake up at the same time in the middle of the night and feel that something is present in the room. You don\'t say anything because you\'re afraid people won\'t believe you.',
  edk_prob3_p2: 'But you know what you feel. And contrary to what many think, the presence of an entity — whether it\'s a restless soul, a djinn or another negative force — is something that can be addressed with the right knowledge and means. You don\'t have to accept it.',
  edk_prob3_p3: 'The Evil Energy Destroy Kit is in these situations more than a cleansing agent — it is a weapon. The combination of charcoal, ghandak, sage and lobhan in the special mix has proven effective through centuries of use in driving away presences. The white candle and the owl feather strengthen the intention. The Blueprint guides you safely through the complete destruction ritual.',
  edk_prob3_s1: 'Waking up at fixed times with a feeling of presence',
  edk_prob3_s2: 'Shadows or movement in the corner of the eye',
  edk_prob3_s3: 'Sudden cold feeling in certain spaces',
  edk_prob3_s4: 'Animals reacting to an invisible presence',

  // ── EDKPurchase ──
  edk_purch_test_badge: '✦ Experiences ✦',
  edk_purch_test_title: 'What Our',
  edk_purch_test_title2: 'Customers Say',
  edk_purch_t1_name: 'Sharona K.',
  edk_purch_t1_text: 'My baby hadn\'t slept through for weeks. After the ritual in the nursery with this kit, it was immediately calmer that night. I cried with relief.',
  edk_purch_t1_sit: 'Nursery',
  edk_purch_t2_name: 'Aziz M.',
  edk_purch_t2_text: 'We had opened a new business in a place where three companies had previously gone bankrupt. After the Destroy Kit ritual we are finally making a profit.',
  edk_purch_t2_sit: 'New Business',
  edk_purch_t3_name: 'Leila V.',
  edk_purch_t3_text: 'I hadn\'t dared to sleep alone in my bedroom for months. After the destruction ritual the feeling of presence is completely gone.',
  edk_purch_t3_sit: 'Presence',
  edk_purch_t4_name: 'Rania H.',
  edk_purch_t4_text: 'The Blueprint makes it so easy. I never thought I could do this myself. It worked perfectly the first time.',
  edk_purch_t4_sit: 'New Home',
  edk_purch_cta_badge: '✦ Do It Now ✦',
  edk_purch_cta_title: 'Destroy The Evil',
  edk_purch_cta_title2: 'Energy Forever',
  edk_purch_cta_sub: 'Stop accepting what you don\'t have to accept. With the right knowledge and materials, you can handle this yourself — today.',
  edk_purch_kit_label: 'Evil Energy Destroy Kit Complete',
  edk_purch_old_price: '€99.95',
  edk_purch_includes_label: 'Including Blueprint, Herbal Mix & Complete Ritual Set',
  edk_purch_added_btn: 'Added to cart!',
  edk_purch_add_btn: 'Add to Cart — €79.95',
  edk_purch_safe_pay: 'Secure payment via Stripe · credit card & iDEAL',
  edk_purch_feat1: 'Blueprint Included',
  edk_purch_feat2: 'Special Herbal Mix',
  edk_purch_feat3: 'Abalone Shell + Feather',
  edk_purch_feat4: 'Charcoal + Candle',
  edk_purch_g1: '100% Pure Natural',
  edk_purch_g2: 'Fast Shipping',
  edk_purch_g3: 'Worldwide Shipping',
  edk_purch_g4: 'ZpiritualZ Guarantee',

  // ── Blue Protect Ritual Steps ──
  bp_rit1_s1: 'Start your day with a warm bath or shower. Use the Blue Protect Soap with slow, upward movements from foot to head — this follows the direction of energy flow.',
  bp_rit1_s2: 'Let the soap soak in for 1–2 minutes while you visualize a clear blue light completely surrounding and protecting you.',
  bp_rit1_s3: 'Rinse off. Gently dry yourself and spray the Blue Protect Spray 4× around your body in a circular motion.',
  bp_rit1_s4: 'Also spray on wrists and neck. Close your eyes and consciously say or think: "I am protected. Negativity has no access to my aura."',

  bp_rit2_s1: 'Fill a warm bath and add 3 tablespoons of Blue Protect Powder. Stir with your hand three times clockwise and speak a protective intention.',
  bp_rit2_s2: 'Let a Blue Protect Ball dissolve in the bath water — the blue extract slowly dissolves and strengthens the cleansing effect of the bath.',
  bp_rit2_s3: 'Get in the bath and relax. Let the blue water work for 20–25 minutes. Breathe consciously and calmly.',
  bp_rit2_s4: 'Submerge your head three times completely. With each moment, imagine how negative energy completely washes away from you.',
  bp_rit2_s5: 'Step out of the bath without rinsing with clean water — keep the protective layer of the powder on your skin.',

  bp_rit3_s1: 'Start at the front door. Sprinkle a thin line of Blue Protect Powder in front of the threshold, from left to right — this creates a protective barrier.',
  bp_rit3_s2: 'Walk through each room clockwise. Sprinkle a small amount of powder in each corner of the room.',
  bp_rit3_s3: 'Spray the Blue Protect Spray in each room: 2–3 sprays upward, toward the ceiling.',
  bp_rit3_s4: 'Close the ritual at the front door with an extra layer of powder and consciously state that evil energies are no longer welcome in your home.',

  bp_rit4_s1: 'Apply a small amount of Blue Protect Powder to the forehead of the child or pregnant woman — this is the traditional protection mark.',
  bp_rit4_s2: 'Also apply to wrists and ankles. These are the most energetically sensitive points of the body.',
  bp_rit4_s3: 'Lightly spray the Blue Protect Spray around the person — hold the spray at arm\'s length and spray from head to feet.',
  bp_rit4_s4: 'Repeat every morning before leaving or after visits from many people. Always repeat after visiting busy places.',

  // ── Evil Energy Ritual Steps ──
  ee_rit1_s1: 'Fill the bath with warm water and add a generous splash of Evil Energy Destroy Cologne to the bath water. Stir with your hand three times clockwise.',
  ee_rit1_s2: 'Step into the bath and let the water soak in for 5 minutes while you breathe calmly and set your intention: protection for the coming day.',
  ee_rit1_s3: 'Wash your body slowly with the Evil Energy Destroy Soap — from foot to head, with upward movements. Visualize how hing forms a repelling shield around your aura.',
  ee_rit1_s4: 'Let the soap soak in for 2 minutes. Rinse off. Dry yourself without rushing. The protection remains active all day.',

  ee_rit2_s1: 'Take a pea-sized amount of Baby Hing Paste on your finger.',
  ee_rit2_s2: 'Gently apply the paste to the baby\'s hair, close to the skull at the back of the head. This is the traditional protection mark.',
  ee_rit2_s3: 'Alternative: make a small ball of the paste and place it under the baby\'s pillow for protection during sleep.',
  ee_rit2_s4: 'Replace the paste daily with fresh paste for optimal effectiveness. Do not use on the face or open skin.',

  ee_rit3_s1: 'Open all windows and doors. Start in the furthest room of the house.',
  ee_rit3_s2: 'Place a teaspoon of Hing Powder on glowing charcoal or in an incense burner. Let the smoke fill the room as you walk through it.',
  ee_rit3_s3: 'Move from room to room toward the front door — always forward, never back. Let the smoke settle in each room for a moment.',
  ee_rit3_s4: 'Finish at the front door. Spray the Evil Energy Destroy Spray 3× in each corner of the hallway and 2× in front of the threshold.',
  ee_rit3_s5: 'Close the front door and leave the house closed with smoke for 15 minutes for full effect. Then ventilate well.',

  ee_rit4_s1: 'Apply the Evil Energy Destroy Hing Oil over a black or white candle — from the bottom upward. This charges the candle with protective intention.',
  ee_rit4_s2: 'Set your intention: consciously speak or think about what you want to be protected against while rubbing the candle.',
  ee_rit4_s3: 'Light the candle in a safe place. As the candle burns, the hing scent spreads protection through the space.',
  ee_rit4_s4: 'Alternative: add 4–5 drops of oil to a diffuser dish with warm water. Let this work all day or night as continuous protection.',

  ee_rit5_s1: 'Add 3 droppers of Evil Energy Destroy Cologne to the mop bucket with water. Stir well.',
  ee_rit5_s2: 'Start in the furthest room of the house. Mop in straight lines, always toward the exit.',
  ee_rit5_s3: 'Mop each room from back to front. Always move toward the front door — this literally moves negative energy out of the house.',
  ee_rit5_s4: 'End at the front door. Mop the threshold itself as the final step. Let the floor dry without rinsing.',

  // ── Common ──
  common_loading: 'Loading...',
  common_error: 'Something went wrong. Please try again.',
  common_required: 'required',
  common_mostChosen: 'Most Popular',
  common_selected: 'Selected',
  common_bestseller: 'Bestseller',
  common_new: 'New',
  common_exclusive: 'Exclusive',
  common_sale: 'Sale',
  common_onceOnly: 'one-time',
  common_pay_safe: 'Secure payment via Stripe',
  common_reviews: 'reviews',
  common_products: 'products',
};

export default en;
